export default "__VITE_ASSET__jw51Dquc__"